import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpXhrBackend, provideHttpClient, withInterceptorsFromDi, withJsonpSupport, withRequestsMadeViaParent } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { RedirectComponent } from './redirect.component';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { TopHeaderComponent } from '../top-header/top-header.component';
import { NavMenuService } from '../nav-menu/nav-menu.service';
import { NavMenuVersionService } from '../nav-menu/nav-menu-version.service';
import { RefreshRedirectComponent } from '../shared/components/refresh-redirect/refresh-redirect.component';


@NgModule({ exports: [
        RedirectComponent
    ],
    declarations: [
        NavMenuComponent,
        TopHeaderComponent,
        RedirectComponent,
        RefreshRedirectComponent
    ], imports: [RouterModule,
        CommonModule,
        FormsModule], providers: [
        NavMenuService,
        NavMenuVersionService,
      provideHttpClient(withJsonpSupport(), withRequestsMadeViaParent())

    ] })
export class RedirectModule { }
